import React from 'react';
import SubscriberLink from '../forms/SubscriberLink';

interface BulletPointType {
    icon: string;
    title: string;
    description: string;
}

interface InfographicsSectionData {
    tagline: string;
    heading: string;
    description: string;
    bulletPoints: BulletPointType[];
    downloadLink: string;
    downloadButton: string;
}

interface InfographicsSectionProps {
    data: InfographicsSectionData;
}

// Infographics section component
const InfographicsSection: React.FC<InfographicsSectionProps> = ({
    data
}) => {
    return (
        <section className="section-large infographics">
            <div className="container-large-2">
                <div className="w-layout-grid bento-grid">
                    <div className="content-wrapper">
                        <div className="limited-heading-set">
                            <div className="tagline-heading">{data.tagline}</div>
                            <div className="heading-set-3">
                                <h2 className="h3-heading">{data.heading}</h2>
                                <div className="description">{data.description}</div>
                            </div>
                        </div>
                        <div className="w-layout-grid content-feature-grid">
                            {data.bulletPoints.map((bullet, index) => (
                                <div key={index} className="content-feature-wrap">
                                    <div className="icon-regular-2 w-embed">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d={bullet.icon} fill="#171717"></path>
                                        </svg>
                                    </div>
                                    <div className="wrap-v-x-small">
                                        <div className="paragraph-large-2 text-weight-medium">
                                            <strong className="bold-text">{bullet.title}</strong>
                                        </div>
                                        <p className="paragraph-small">{bullet.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <SubscriberLink href={data.downloadLink} target="_blank" className="button-left-icon w-inline-block">
                            <div className="button-icon-left"></div>
                            <div className="text-block-4">{data.downloadButton}</div>
                        </SubscriberLink>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InfographicsSection;
